"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var VarDirective = /** @class */ (function () {
    function VarDirective(vcRef, templateRef) {
        this.vcRef = vcRef;
        this.templateRef = templateRef;
        this.context = {};
    }
    Object.defineProperty(VarDirective.prototype, "ngVar", {
        set: function (context) {
            this.context.$implicit = this.context.ngVar = context;
            this.updateView();
        },
        enumerable: true,
        configurable: true
    });
    VarDirective.prototype.updateView = function () {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    };
    VarDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[ngVar]',
                },] },
    ];
    /** @nocollapse */
    VarDirective.ctorParameters = function () { return [
        { type: core_1.ViewContainerRef, },
        { type: core_1.TemplateRef, },
    ]; };
    VarDirective.propDecorators = {
        "ngVar": [{ type: core_1.Input },],
    };
    return VarDirective;
}());
exports.VarDirective = VarDirective;
//# sourceMappingURL=ng-var.directive.js.map